import round from '../../../utils/round';

const indicatorInterventionsEconomic = (filteredInterventionZones) => {

  return filteredInterventionZones.reduce(
    (totals, zone) => {
      return {
        plannedIncome: totals.plannedIncome +
          (zone.interventions || [])
            .reduce((sum, intervention) => sum + round(Number(intervention.planned_income) || 0), 0),
        plannedInvest: totals.plannedInvest +
          (zone.interventions || [])
            .reduce((sum, intervention) => sum + round(Number(intervention.planned_invest) || 0), 0),
        executedIncome: totals.executedIncome +
          (zone.interventions || [])
            .flatMap(intervention => intervention.executions || [])
            .reduce((sum, exec) => sum + round(Number(exec.executed_income) || 0), 0),
        executedInvest: totals.executedInvest
          + (zone.interventions || [])
            .flatMap(intervention => intervention.executions || [])
            .reduce((sum, exec) => sum + round(Number(exec.executed_invest) || 0), 0)
      };
    },
    { plannedIncome: 0, plannedInvest: 0, executedIncome: 0, executedInvest: 0 }
  );
};

export default indicatorInterventionsEconomic;